import { checkErrorDniFormat } from '@chilecompra/react-kit'
import { CLEAN_DNI } from '../../config/settings/regexes'

/**
 * To clean a value that is formatted as a Chilean DNI.
 * Returns the given value without points and hyphen.
 */
export const cleanDNI = value => {
  return typeof value === 'string' ? value.replace(CLEAN_DNI, '').toUpperCase() : ''
}

/**
 * To check if a DNI corresponds to a natural person or not.
 * This implementation is momentary.
 */
export const isNaturalPerson = value => {
  value = cleanDNI(value?.toString())
  const dni = value.substring(0, value.length - 1)

  return parseInt(dni, 10) < 50000000
}

/**
 * To check if the given value corresponds to a foreign buyer.
 */
export const checkIfForeignDni = value => !checkErrorDniFormat(value)

/**
 * To get the last Sunday.
 */
export const getLastSunday = () => {
  const now = new Date()
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
  return new Date(today.setDate(today.getDate() - today.getDay()))
}

/**
 * To get dynamic scale from Y-axis from Column Chart.
 */

export const calculateYAxisScale = series => {
  // 1. Get all values from the "chartData" arrays
  const allValues = series.flatMap(item => item.data)

  // 2. Find the maximum value among all data points
  const maxNumber = Math.max(...allValues)

  // 3. Adjust the rounding to avoid aggressive scaling
  const scaleStep = Math.pow(10, Math.floor(Math.log10(maxNumber)))
  let roundedMax

  // If the value exceeds the nearest multiple by less than half the step, adjust it to the lower value
  if (maxNumber <= scaleStep * 1.5) {
    roundedMax = scaleStep * 1.5 // Por ejemplo, 15000 si scaleStep es 10000
  } else {
    roundedMax = Math.ceil(maxNumber / scaleStep) * scaleStep // Redondear hacia arriba
  }

  // 4. Determine the number of intervals we want
  const numberOfTicks = 8 // it can adjust this as needed
  const tickInterval = roundedMax / numberOfTicks

  // 5. Generate the tick positions for the Y-axis
  const tickPositions = []
  for (let i = 0; i <= numberOfTicks; i++) {
    tickPositions.push(i * tickInterval)
  }

  return tickPositions
}

export const parseServiceError = (error, defaultError) =>
  error?.originalError?.message ?? error?.message ?? defaultError

/**
 * To safely call a service and return the data and error.
 */
export const safeServiceCall = async (serviceCall, defaultError) => {
  try {
    const { data, errores } = await serviceCall()
    return { data: data ?? null, error: errores ?? null }
  } catch (error) {
    return { data: null, error: parseServiceError(error, defaultError) }
  }
}
